import React from 'react';
import clsx from 'clsx';

import styles from './InfoText.module.scss';

interface InfoTextProps {
  error?: boolean;
  style?: React.CSSProperties;
}

const InfoText = ({
  error,
  style,
  children,
}: React.PropsWithChildren<InfoTextProps>) => (
  <span style={style} className={clsx(styles.InfoText, error && styles.error)}>
    {children}
  </span>
);

export default InfoText;
